import React from "react";

import { moneyFormat } from "./format";
import TwoPanels from "./TwoPanels";
import Text from "./Text";
import { IncomeStatementPanel } from "./IncomeStatement";

const MarketingFinancialImpact1 = ({ incomeStatement }) => (
  <TwoPanels
    title1="Financial Impact of Marketing Decisions"
    title2="Income Statement"
  >
    <fragment>
      <Text>
        As a result of your product and marketing decisions, total dollar sales
        for your products were as follows:
      </Text>
      <Text>
        <b>Net Revenues</b>: Your Net revenues of{" "}
        {moneyFormat(incomeStatement["Net Revenues"])} was driven by the
        attractiveness of your Marketing Mix in relation to your competitors.
      </Text>
    </fragment>
    <IncomeStatementPanel sheet={incomeStatement} />
  </TwoPanels>
);

export default MarketingFinancialImpact1;



// WEBPACK FOOTER //
// ./src/components/analysis/MarketingFinancialImpact1.js